import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material"
import Grid from "@mui/material/Grid2"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import React from "react"
import { DDMMYYYY_SLASH } from "../../utils/constants"

function FormField(props) {
  const {
    label,
    name,
    value = "",
    deattach,
    onChange,
    placeholder,
    type = "text",
    autoCapitalize = true,
    autoCapitalizeAllWords = false,
    autoCapitalizeAllChars = false,
    errorMessage = "",
    isError = false,
    style,
    required = false,
    labelStyles = {},
    labelClassName = "",
    textSize = "small",
    dropDownSize = "small",
    dateSize = "small",
    dropdownStyles = {},
    dropDownSelectStyle = {},
    isNumberOnly = false,
    maxLength
  } = props
  let customStyles = {}
  if (deattach) {
    customStyles = { display: "flex", alignItems: "center" }
  }

  if (type === "dropdown") {
    const { options, show } = props

    return (
      <div className="field-container" style={{ ...customStyles }}>
        {deattach && (
          <Typography
            fullWidth
            variant="body1"
            sx={{
              fontWeight: "bold",
              flexGrow: 1,
              marginRight: "10px",
              width: "100%",
            }}
            className={labelClassName}
          >
            {label}
          </Typography>
        )}

        <FormControl
          fullWidth
          variant="outlined"
          size={dropDownSize}
          style={dropdownStyles}
        >
          {!deattach && (
            <InputLabel>
              {label}
              {required && <span style={{ color: "red" }}>*</span>}
            </InputLabel>
          )}

          <Select
            label={deattach ? "" : label}
            name={name}
            value={value}
            size={dropDownSize}
            onChange={onChange}
            placeholder={placeholder}
            fullWidth
            sx={{
              width: "100%",
              borderRadius: "5px",
              ...dropDownSelectStyle,
            }}
            disabled={props.disabled}
            displayEmpty={deattach}
            renderValue={(selected) => {
              if (!selected) {
                return <span style={{ color: "#666666" }}>{placeholder}</span>
              }
              const selectedOption = options.find(
                (option) => option.value === selected,
              )
              return selectedOption
                ? selectedOption.label
                : value
                  ? value?.label
                  : ""
            }}
          >
            {options?.map((option) => (
              <MenuItem key={option?._id} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    )
  } else if (type === "date") {
    return (
      <div className="field-container" style={{ ...customStyles }}>
        {/* <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                {label}
            </Typography> */}
        {deattach && (
          <Typography
            fullWidth
            variant="body1"
            sx={{
              fontWeight: "bold",
              flexGrow: 1,
              marginRight: "10px",
              width: "100%",
            }}
            className={labelClassName}
          >
            {label}
          </Typography>
        )}

        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={deattach ? "" : label}
            value={value || null} // Set default to current date if formData.dob is empty
            fullWidth
            sx={{
              width: "100%",
              borderRadius: "10px",
            }}
            slotProps={{ textField: { size: dateSize } }}
            renderInput={(params) => (
              <TextField {...params} sx={{ width: "100%", borderRadius: "10px" }} />
            )}
            onChange={onChange}
            format={DDMMYYYY_SLASH}
          />
        </LocalizationProvider>
      </div>
    )
  }

  function onChangeText(e) {
    let value = e.target.value
    if (maxLength && (maxLength < value.length)) {
      return false
    }

    if (type === "email") {
      value = value.toLowerCase()
    }

    if (isNumberOnly) {
      if (/[^0-9]/.test(value)) {
        return;
      }
    }

    if (value) {
      let newValue = value
      if (autoCapitalizeAllChars) {
        newValue = value.toUpperCase()
      } else if (autoCapitalizeAllWords) {
        newValue = value
          ?.split("")
          ?.map((word) => word[0]?.toUpperCase() + word.slice(1))
          .join(" ")
      } else if (autoCapitalize) {
        newValue = value[0]?.toUpperCase() + value.slice(1)
      }
      e.target.value = newValue
    }

    // console.log("onChangeTextonChangeText", e.target.value, value, value?.[0]?.toUpperCase() + value.slice(1))
    onChange(e)
  }

  return (
    <Grid className="field-container" sx={{ ...customStyles }} style={style}>
      {deattach && (
        <Typography
          htmlFor={name}
          sx={{
            fontWeight: "bold",
            marginBottom: "5px",
            flexGrow: 1,
            // marginRight: "10px",
            ...labelStyles,
            boxSizing: "border-box",
            // , width: "100%",
            // border: "2px solid blue"
          }}
          className={labelClassName}
        >
          {label}
        </Typography>
      )}

      <div style={{ flexGrow: 1, width: "100%" }}>
        <TextField
          size={textSize}
          id={name}
          name={name}
          value={value}
          onChange={onChangeText}
          type={type}
          fullWidth
          // className="form-input"
          label={deattach ? "" : label}
          placeholder={deattach ? label : ""}
        />

        {errorMessage && (
          <FormHelperText
            id="component-helper-text"
            style={{
              margin: "0px",
              color: isError ? "red" : "grey",
            }}
          >
            {errorMessage}
          </FormHelperText>
        )}
      </div>
    </Grid>
  )
}

export { FormField }
